import axios from 'axios';
import apiConfig from '../api.config';

export default async function sendCustomerInvitationRequest({
  chainName,
  name,
  phone,
  email,
  //pms,
  //countryChain,
  ownerId,
}) {
  const {
    host,
    URIs: { sendCustomerInvitation },
  } = apiConfig;

  const uri = `${host}${sendCustomerInvitation}`;

  const res = await axios.post(
    uri,
    JSON.stringify({ chainName, name, phone, email, ownerUserId: ownerId }),
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );
  return res.data;
}
